import axios from "axios";

class newsService {
  async createNews(data: any) {
    return await axios.post("news", data);
  }

  async getAll() {
    return await axios.get("news");
  }

  async updateNews(id: number, body: any) {
    // console.log(body);
    return await axios.put(`news/${id}`, body);
  }

  async delete(id: number) {
    return await axios.delete(`news/${id}`);
  }

  async getShow() {
    return await axios.get("news/show");
  }
}
export default new newsService();
